import { AddEmployeesToWorkersResponse, AddEmployeesToWorkersSubcontractorRequest, AddImageToProjectAndDiaryRecordResponse, AddRemoveFileDiaryRecordDTO, AddRemoveFilesDiaryRecordSubcontractorRequest, AddWealthsToMechanismsResponse, AddWealthsToMechanismsSubcontractorRequest, AuthOldErpSubcontractorRequest, AuthOldErpSubcontractorResponse, AuthSubcontractorRequest, AuthSubcontractorResponse, BuildingDTO, CopyDiaryRecordSubcontractorRequest, CreateSubcontractorDailyRecordRequest, CreateSubcontractorUserRequest, CreateSubcontractorUserResponse, DailyRecordSearchDTO, DeleteFileRelationDiarySubcontractorRequest, DeleteSubcontractorDailyRecordRequest, DeleteSubcontractorDiariesRequest, DiaryLogDTO, DiaryPrintType, EmployeeGroupDTO, EmployeeInGroupDTO, FileDiaryDTO, FileDirectoryDTO, FileParameter, FileResponse, FileToTransferDTO, GetBuildingWeatherByDiaryIdResponse, GetBuildingWeatherByDiaryIdSubcontractorRequest, GetDailyFullRecordResponse, GetDailyFullRecordSubcontractorRequest, GetDailyRecordsForSubcontractorAndDiaryResponse, GetDailyRecordsForSubcontractorByRecordIdResponse, GetDailyRecordsForUserDTO, GetDiariesForUserDTO, GetDiaryDataDetailResponse, GetDiaryRecordDataNotTablesResponse, GetDiarySearchResultSubcontractorRequest, GetDownloadForSignedSubcontractorDiaryRequest, GetImagesUrlsForRecordResponse, GetMachinesForRecordTableDTO, GetMachinesForRecordTableSubcontractorRequest, GetMaterialsForRecordTableDTO, GetMaterialsForRecordTableSubcontractorRequest, GetMaterialsForRecordsExcelSubcontractorRequest, GetPhotosFromBuildingToDiaryChooseResponse, GetPrintDiaryInDateRangeRequest, GetPrintStatusRequest, GetPrintStatusResponse, GetSignaturesForRecordResponse, GetSubcontractorDiaryPermissionsResponse, GetSubcontractorInfoRequest, GetSubcontractorInfoResponse, GetTodosForDiaryDTO, GetUserIdRequest, GetUserIdResponse, GetWeatherForRecordDTO, GetWeatherForRecordSubcontractorRequest, GetWorkerForRecordDTO, GetWorkersForRecordSubcontractorRequest, GroupAdminDTO, ImageDiaryDTO, InvestorsChatMessageDTO, LockSubcontractorDiaryRecordRequest, MoveDialyRecordsFromTrashSubcontractorRequest, PostDiaryChatMessageInvestorsSubcontractorRequest, PostDiaryChatMessageSubcontractorsAsSubcontractorsRequest, PrintDiaryBackgroundRequest, PrintSignedDiaryRecordsZIPRequest, RefreshTokenSubcontractorRequest, ResetSubcontractorPasswordRequest, ResetSubcontractorPasswordResponse, SaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest, SaveDiaryContentsSubcontractorRequest, SaveDiaryContentsSubcontractorResponse, SaveDiarySignatureAdminUserResponse, SaveMachinesTableReqDTO, SaveMachinesTableSubcontractorRequest, SaveMaterialsTableReqDTO, SaveMaterialsTableSubcontractorRequest, SaveRotatedImageResponse, SaveRotatedImageSubcontractorRequest, SaveSubcontractorDiaryRequest, SaveWeatherReqDTO, SaveWeathersSubcontractorRequest, SaveWorkerReqDTO, SaveWorkersSubcontractorRequest, SendMessageSubcontractorDiaryRequest, SubcontractorsChatMessageDTO, TransferPhotosFromProjectSubcontractorRequest, UpdateSubcontractorPasswordRequest, UpdateSubcontractorPasswordResponse, UploadDigitalSignedPDFResponse, UploadFileToDiaryDirectResponse, UserDTO, UserGroupDTO, UserRoleDTO, UsersGroupDiaryDTO, WealthForDiaryDialogDTO } from "./ApiServerVov";
import { ApiSubcontractorOldBaseHelper, SingletonRefreshClientSubcontractorOld } from "./ApiSubcontractorOldBaseHelper";

export class APIVovSubcontractorHelper extends ApiSubcontractorOldBaseHelper {
    public async LoginSubcontractor(userName: string, password: string, domain: string): Promise<AuthSubcontractorResponse> {
        let res = (await this.GetClientToAuth().authSubcontractor(new AuthSubcontractorRequest({ subcontractorUsername: userName, password: password, application: domain })))!;
        if (res.isSubcontractor) {
            localStorage.setItem('subcontractor_token_old', res.token!);
            localStorage.setItem('subcontractor_token_old_refresh', res.refreshToken!);
            localStorage.setItem('subcontractor_token_old_expires', res.dateTimeExpires!.toString());
        }
        return res;
    }

    public async RefreshSubcontractorToken(): Promise<boolean> {
        SingletonRefreshClientSubcontractorOld.setRefresh();
        let t = (await this.GetAdressedAuthRefreshableClient()
            .refreshSubcontractorToken(new RefreshTokenSubcontractorRequest(
                {
                    accessToken: localStorage.getItem('subcontractor_token_old')!,
                    refreshToken: localStorage.getItem('subcontractor_token_old_refresh')!
                }
            )));
        localStorage.setItem('subcontractor_token_old', t.accessToken!);
        localStorage.setItem('subcontractor_token_old_refresh', t.refreshToken!);
        localStorage.setItem('subcontractor_token_old_expires', t.expireAt!.toString());
        SingletonRefreshClientSubcontractorOld.completeRefresh();
        return true;
    }

    public async GetDiaryRecordsSubcontractor(deleted: boolean): Promise<GetDailyRecordsForUserDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDailyRecordsForSubcontractorUser(deleted)).diaries!;
    }

    public async deleteSubcontractorDiaryRecords(recordsIds: number[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteSubcontractorDiaryRecords(new DeleteSubcontractorDailyRecordRequest({ diaryRecordsIds: recordsIds }))).ok!);
    }


    public async GetUser(): Promise<GetUserIdResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getUserIdSub(new GetUserIdRequest()));
    }


    public async GetSubcontractorDiaries(deleted: boolean, onlyMain: boolean, buildingId?: number): Promise<GetDiariesForUserDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiariesForSubcontractorUser(deleted, onlyMain, buildingId ? buildingId : 0)).diaries!;
    }

    public async deleteSubcontractorDiaries(diaryIds: number[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteSubcontractorDiaries(new DeleteSubcontractorDiariesRequest({ diaryIds: diaryIds }))).ok!);
    }

    public async GetSubcontractorDiaryPermissions(): Promise<GetSubcontractorDiaryPermissionsResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getSubcontractorDiaryPermissions());
    }

    public async GetCompanyNameForSubcontractorDiary(): Promise<string> {
        return (await this.GetAdressedAuthRefreshableClient().getCompanyNameForSubcontractorDiary()).companyName!;
    }

    public async GetSubcontractorDiaryDataDetail(diaryId: number): Promise<GetDiaryDataDetailResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getSubcontractorDiaryDataDetail(diaryId))!;
    }

    public async SaveSubcontractorDiary(req: Partial<GetDiaryDataDetailResponse>): Promise<boolean> {
        return (await this.GetAdressedAuthRefreshableClient().saveSubcontractorDiary(new SaveSubcontractorDiaryRequest({
            id: req.id,
            authorWatch: req.authorWatch,
            buildingId: req.buildingId,
            city: req.city,
            constructionContractor: req.constructionContractor,
            constructionManager: req.constructionManager,
            diaryName: req.diaryName,
            district: req.district,
            generalArchitect: req.generalArchitect,
            generalContractor: req.generalContractor,
            investor: req.investor,
            place: req.place,
            projectManager: req.projectManager,
            responsibleArchitect: req.responsibleArchitect,
            responsibleCompany: req.responsibleCompany,
            section: req.section,
            subcontractors: req.subcontractors,
            tdsPermament: req.tdsPermament,
            tdsTemporary: req.tdsTemporary,
            technologicallContractor: req.technologicallContractor,
            groupId: req.groupId,
            parentDiaryId: req.parentDiaryId,
            users: req.users,
            authorizedPerson: req.authorizedPerson,
            isActive: req.isActive
        }))).ok!;
    }

    public async PrintSubcontractorDiaryRecord(diaryRecordId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasPhotos: boolean): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryRecordSubcontractor(diaryRecordId, onlyMyNotes, hasDigitalSignatureField, hasPhotos));
    }

    public async PrintTitlePageSubcontractor(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiarySubcontractorTitlePage(diaryId, onlyMyNotes, hasDigitalSignatureField));
    }

    public async PrintSubcontractorDiary(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasPhotos: boolean): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiarySubcontractor(diaryId, onlyMyNotes, hasDigitalSignatureField, hasPhotos));
    }

    public async PrintSignedDiaryRecordsZIP(diaryId: number): Promise<void> {
        return (await this.GetAdressedAuthRefreshableClient().printSignedDiaryRecordsZIPSubcontractor(new PrintSignedDiaryRecordsZIPRequest({ diaryId: diaryId, apiAdress: '' })));
    }

    public async PrintDiaryInDateRange(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, dateFrom: Date, dateTo: Date, hasPhotos: boolean): Promise<FileResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryInDateRangeSubcontractor(new GetPrintDiaryInDateRangeRequest({ dateFrom: dateFrom, dateTo: dateTo, diaryId: diaryId, hasAttachments: false, hasDigitalSignatureField: hasDigitalSignatureField, onlyMyNotes: onlyMyNotes, hasPhotos: hasPhotos })));
    }

    public async PrintDiaryInDateRangeBackground(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, dateFrom: Date, dateTo: Date, hasPhotos: boolean): Promise<void> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryBackgroundSubcontractor(new PrintDiaryBackgroundRequest({ dateFrom: dateFrom, dateTo: dateTo, diaryId: diaryId, hasAttachments: false, hasDigitalSignatureField: hasDigitalSignatureField, onlyMyNotes: onlyMyNotes, printType: DiaryPrintType.DiaryInRange, hasPhotos: hasPhotos })));
    }

    public async GetPrintStatusSubcontractor(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean): Promise<GetPrintStatusResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getPrintStatusSubcontractor(new GetPrintStatusRequest({ diaryId: diaryId, onlyMyNotes: onlyMyNotes, hasDigitalSignatureField: hasDigitalSignatureField, hasAttachments: hasAttachments })));
    }

    public async PrintWholeSubcontractorDiary(diaryId: number, onlyMyNotes: boolean): Promise<string | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().printWholeSubcontractorDiary(diaryId, onlyMyNotes)).downloadUri;
    }

    public async DownloadSubcontractorFile(file: string): Promise<FileResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getSubcontractorDownloadLinkOldErp(new GetDownloadForSignedSubcontractorDiaryRequest({ url: file })));
    }

    public async GetRecordsForViewing(recordId: number): Promise<GetDailyRecordsForSubcontractorAndDiaryResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDailyRecordsForSubcontractorAndDiary(recordId));
    }

    public async LoginErp(token: string, adminUserId: number, domain: string): Promise<AuthOldErpSubcontractorResponse> {
        let t = (await this.GetClientToAuth().loginOldErp(new AuthOldErpSubcontractorRequest({ adminUserId: adminUserId, token: token })));
        localStorage.setItem('subcontractor_token_old', t.token!);
        localStorage.setItem('subcontractor_old_app_uri', domain);
        console.log(t);
        return t;
    }

    public async SubcontractorGroups(): Promise<UserGroupDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().subcontractorGroup()).groups!;
    }

    public async GetBuildingForSubcontractor(diaryId: number): Promise<BuildingDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().buildingSubcontractor(diaryId)).buildings!;
    }

    public async GetRecordsForViewingStateless(recordId: number): Promise<GetDailyRecordsForSubcontractorByRecordIdResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDailyRecordsForSubcontractorByRecordId(recordId));
    }

    public async GetFullDailyRecordNotTables(recordId: number, sharedOnly: boolean): Promise<GetDiaryRecordDataNotTablesResponse> {
        // console.log(sharedOnly);
        return (await this.GetAdressedAuthRefreshableClient().diaryRecordDataNotTablesSubcontractor(recordId));
    }

    public async saveDiaryContents(diaryRecordId: number, stamp: number, works?: string | undefined,
        machines?: string | undefined, materials?: string | undefined, notes?: string | undefined, contents?: GroupAdminDTO[] | undefined): Promise<SaveDiaryContentsSubcontractorResponse> {
        return ((await this.GetAdressedAuthRefreshableClient().saveDiaryContentsSubcontractor(
            new SaveDiaryContentsSubcontractorRequest({
                completedWorks: works, completedWorksLastUpdate: stamp, diaryId: diaryRecordId,
                machines: machines, materials: materials, additionalNotes: notes,
                contents: contents
            }))));
    }

    public async RingOthersDiary(diaryRecordId: number): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().sendMessageSubcontractorDiary(new SendMessageSubcontractorDiaryRequest({ diaryRecordId: diaryRecordId }))).ok;
    }

    public async createDiaryRecord(diaryId: number, date: Date): Promise<number | string> {
        let data = (await this.GetAdressedAuthRefreshableClient().createSubcontractorDiaryRecord(new CreateSubcontractorDailyRecordRequest({ date: date, diaryId: diaryId })));
        if (data.newId)
            return data.newId;
        else return data.error!;
    }

    public async lockUnlockDiaryRecord(diaryRecordId: number, locked: boolean): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().lockUnlockSubcontractorDiaryRecord(
            new LockSubcontractorDiaryRecordRequest({ diaryRecordId: diaryRecordId, lock: locked }))).ok!);
    }

    public async GetSignaturesForRecord(recordId: number): Promise<GetSignaturesForRecordResponse | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getSignaturesForSubcontractorRecord(recordId, false));
    }

    public async UploadDigitallySignedPDF(file: FileParameter, diaryIdRecord: number): Promise<UploadDigitalSignedPDFResponse> {
        return (await this.GetAdressedAuthRefreshableClient().uploadDigitallySignedPDFSubcontractor(diaryIdRecord, file));
    }

    public async UploadSignature(file: FileParameter, diaryIdRecord: number, isInvestor: boolean): Promise<SaveDiarySignatureAdminUserResponse> {
        return (await this.GetAdressedAuthRefreshableClient().uploadSignatureSubcontractor(diaryIdRecord, file, isInvestor));
    }

    public async GetCompletedWorksRecord(recordId: number): Promise<string | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getCompletedWorksSubcontractor(recordId)).completedWorks;
    }

    public async GetImagesForRecord(recordId: number): Promise<GetImagesUrlsForRecordResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryImagesSubcontractor(recordId, false));
    }

    public async getPhotosBuildingToChoose(diaryRecordId: number): Promise<GetPhotosFromBuildingToDiaryChooseResponse> {
        let data = (await this.GetAdressedAuthRefreshableClient().getPhotosBuildingToChooseSubcontractor(diaryRecordId, false));
        return data;
    }

    public async deleteDiaryImageRel(diaryRecordId: number, imageName: string): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteImageRelationSubcontractor(diaryRecordId, imageName)).ok!);
    }

    public async GetAttachmentsForRecord(recordId: number): Promise<FileDiaryDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getFilesForDiarySubcontractor(recordId)).files;
    }

    public async deleteRecordFileRel(diaryRecordId: number, fileId: number): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().deleteFileRelSubcontractor(new DeleteFileRelationDiarySubcontractorRequest({ diaryRecordsId: diaryRecordId, fileId: fileId }))).ok!);
    }

    public async GetWeatherForRecord(recordId: number, onlyShared: boolean): Promise<GetWeatherForRecordDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getWeatherForRecordSubcontractor(new GetWeatherForRecordSubcontractorRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).weathers!;
    }

    public async saveWeathers(diaryRecordId: number, weathers: SaveWeatherReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveWeathersSubcontractor(new SaveWeathersSubcontractorRequest({ diaryId: diaryRecordId, weathers: weathers }))).ok!);
    }

    public async GetWeatherFromBuildingForRecord(diaryRecordId: number, hour: number, date: Date): Promise<GetBuildingWeatherByDiaryIdResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getWeatherForDiaryRecordSubcontractor(new GetBuildingWeatherByDiaryIdSubcontractorRequest({ dairyRecordId: diaryRecordId, date: date, hour: hour })));
    }
    public async SaveWeatherFromBuildingForRecord(diaryRecordId: number, hour: number, date: Date): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().saveWeatherToDiaryRecordSubcontractor(new SaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest({ dairyRecordId: diaryRecordId, date: date, hour: hour }))).ok;
    }

    public async GetWorkersForRecord(recordId: number, onlyShared: boolean): Promise<GetWorkerForRecordDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getWorkersForRecordSubcontractor(new GetWorkersForRecordSubcontractorRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).workers!;
    }

    public async saveWorkers(diaryRecordId: number, workers: SaveWorkerReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveWorkersSubcontractor(new SaveWorkersSubcontractorRequest({ diaryId: diaryRecordId, workers: workers }))).ok!);
    }

    public async GetEmployeesWithGroups(diaryRecordId: number): Promise<EmployeeGroupDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getEmployeesWithGroupsSubcontractor(diaryRecordId)).employeesWithGroups;
    }

    public async AddEmpsToDiary(diaryRecordId: number, emps: EmployeeInGroupDTO[]): Promise<AddEmployeesToWorkersResponse> {
        return (await this.GetAdressedAuthRefreshableClient().addEmployeesToWorkersSubcontractor(new AddEmployeesToWorkersSubcontractorRequest({ diaryRecordsId: diaryRecordId, employees: emps })));
    }

    public async GetMaterialsForRecord(recordId: number, onlyShared: boolean): Promise<GetMaterialsForRecordTableDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getMaterialsForRecordTableSubcontractor(new GetMaterialsForRecordTableSubcontractorRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).materials!;
    }

    public async saveMaterials(diaryRecordId: number, materials: SaveMaterialsTableReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveMaterialsTableSubcontractor(new SaveMaterialsTableSubcontractorRequest({ diaryId: diaryRecordId, materials: materials }))).ok!);
    }

    public async GetMachinesForRecord(recordId: number, onlyShared: boolean): Promise<GetMachinesForRecordTableDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getMachinesForRecordTableSubcontractor(new GetMachinesForRecordTableSubcontractorRequest({
            diaryRecordId: recordId,
            onlyShared: onlyShared,
            onlyMine: false,
        }))).machines!;
    }

    public async saveMachines(diaryRecordId: number, machines: SaveMachinesTableReqDTO[]): Promise<boolean> {
        return ((await this.GetAdressedAuthRefreshableClient().saveMachinesTableSubcontractor(new SaveMachinesTableSubcontractorRequest({ diaryId: diaryRecordId, machines: machines }))).ok!);
    }

    public async GetWealthsForDiaryDialog(diaryRecordId: number): Promise<WealthForDiaryDialogDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getWealthsForDiaryDialogSubcontractor(diaryRecordId)).wealthsForDiaryDialog;
    }

    public async AddWealthsToMechanisms(diaryRecordId: number, checkedWealthsIds: number[]): Promise<AddWealthsToMechanismsResponse> {
        return (await this.GetAdressedAuthRefreshableClient().addWealthsToMechanismsSubcontractor(new AddWealthsToMechanismsSubcontractorRequest({ diaryRecordsId: diaryRecordId, checkedWealthsIds: checkedWealthsIds })));
    }

    public async UploadPdfFileForSignatureLogged(file: FileParameter, diaryIdRecord: number): Promise<FileResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getOneDayPDFLoggedSubcontractor(diaryIdRecord, file));
    }

    public async GetFullDailyRecord(recordId: number, domain: string, base64: boolean, sharedOnly: boolean, onlyMine?: boolean, subcontractorId?: number): Promise<GetDailyFullRecordResponse> {
        // console.log(sharedOnly);
        return (await this.GetAdressedAuthRefreshableClient().fullDayRecordSubcontractor(
            new GetDailyFullRecordSubcontractorRequest({
                diaryRecordId: recordId,
                domain: domain,
                getBase64Images: base64,
                onlyShared: sharedOnly,
                onlyMine: onlyMine !== undefined && onlyMine === true,
                subcontractorId: subcontractorId
            })));
    }

    public async GetDiarySearchResult(diarId: number | undefined, sText: string, datFrom: Date | undefined, datTo: Date | undefined): Promise<DailyRecordSearchDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiarySearchResultSubcontractor(new GetDiarySearchResultSubcontractorRequest({ diaryId: diarId, searchText: sText, dateFrom: datFrom, dateTo: datTo }))).records!;
    }

    public async copyDiaryRecord(diaryId: number, dateFrom: Date, dateTo: Date, onlyWorkDays: boolean, completedWork: string, mach: SaveMachinesTableReqDTO[], mat: SaveMaterialsTableReqDTO[], works: SaveWorkerReqDTO[]): Promise<boolean> {
        let data = (await this.GetAdressedAuthRefreshableClient().copyDiaryRecordSubcontractor(new CopyDiaryRecordSubcontractorRequest({ diaryId: diaryId, dateFrom: dateFrom, dateTo: dateTo, onlyWorkDays: onlyWorkDays, completedWorks: completedWork, machines: mach, materials: mat, workers: works })));
        return data.ok!;
    }

    public async GetTodosForRecord(recordId: number): Promise<GetTodosForDiaryDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getTodosForDiarySubcontractor(recordId)).todos;
    }

    public async GetInvestorsChatMessages(recordId: number): Promise<InvestorsChatMessageDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getInvestorsChatMessagesSubcontractor(recordId)).messages;
    }

    public async GetSubcontractorsChatMessages(recordId: number): Promise<SubcontractorsChatMessageDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getSubcontractorsChatForSubcontractorMessages(recordId)).messages;
    }

    public async PostInvestorsMessage(recordId: number, message: string): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().sendInvestorsChatMessageSubcontractor(new PostDiaryChatMessageInvestorsSubcontractorRequest({
            diaryRecordId: recordId,
            text: message
        }))).ok;
    }

    public async PostSubcontractorsMessage(recordId: number, message: string): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().sendSubcontractorsChatMessageAsSubcontractor(new PostDiaryChatMessageSubcontractorsAsSubcontractorsRequest({
            diaryRecordId: recordId,
            text: message
        }))).ok;
    }

    public async SaveRotatedImageToDiary(diaryRecordId: number, imagePath: string, rotation: number): Promise<SaveRotatedImageResponse> {
        return (await this.GetAdressedAuthRefreshableClient().saveRotatedImageSubcontractor(new SaveRotatedImageSubcontractorRequest({ buildingDiaryRecordId: diaryRecordId, rotation: rotation, uri: imagePath })));
    }

    public async TransferPhotosFromProject(recordId: number, images: FileToTransferDTO[]): Promise<boolean | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().transferPhotoFromProjectSubcontractor(new TransferPhotosFromProjectSubcontractorRequest({
            diaryRecordId: recordId,
            filenames: images
        }))).ok;
    }

    public async addImageToDiary(diaryRecordId: number, file: FileParameter): Promise<AddImageToProjectAndDiaryRecordResponse> {
        let data = (await this.GetAdressedAuthRefreshableClient().uploadImageSubcontractor(diaryRecordId, file));
        return data;
    }

    public async addFileToDiary(diaryRecordId: number, file: FileParameter): Promise<UploadFileToDiaryDirectResponse> {
        let data = (await this.GetAdressedAuthRefreshableClient().addFileToRecordDirectSubcontractor(diaryRecordId, file));
        return data;
    }

    public async GetFilesFromProject(recordId: number): Promise<FileDirectoryDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getFilesFromBuildingForDiarySubcontractor(recordId)).files;
    }

    public async addRemoveFileToDiaryRecord(diaryRecordId: number, files: AddRemoveFileDiaryRecordDTO[]): Promise<boolean | undefined> {
        let data = (await this.GetAdressedAuthRefreshableClient().addRemoveFilesDiaryRecordSubcontractor(new AddRemoveFilesDiaryRecordSubcontractorRequest({ diaryRecordId: diaryRecordId, files: files })));
        return data.ok;
    }

    public async MoveDailyRecordsFromTrash(recordsIds: number[]): Promise<boolean> {
        return (await this.GetAdressedAuthRefreshableClient().moveDailyRecordsFromTrashSubcontractor(new MoveDialyRecordsFromTrashSubcontractorRequest({ deletedDailyRecordsIds: recordsIds }))).ok!;
    }

    public async GetSubcontractorInfo(): Promise<GetSubcontractorInfoResponse> {
        return (await this.GetAdressedAuthRefreshableClient().getSubcontractorInfo(new GetSubcontractorInfoRequest()))!;
    }

    public async UpdateSubcontractorPassword(oldPass: string, newPass: string): Promise<UpdateSubcontractorPasswordResponse> {
        return (await this.GetAdressedAuthRefreshableClient().updateSubcontractorPassword(new UpdateSubcontractorPasswordRequest({ oldPassword: oldPass, newPassword: newPass })));
    }
    public async ResetSubcontractorPassword(domain: string, email: string): Promise<ResetSubcontractorPasswordResponse> {
        return (await this.GetAdressedAuthRefreshableClient().resetSubcontractorPassword(new ResetSubcontractorPasswordRequest({ domain: domain, email: email })));
    }

    public async GetDiaryRecordLog(recordId: number): Promise<DiaryLogDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryRecordLogSubcontractor(recordId)).logs!;
    }

    public async CreateSubcontractorUser(name: string, email: string, groupId: number | undefined, diaryId?: number, roleId?: number): Promise<CreateSubcontractorUserResponse> {
        return (await this.GetAdressedAuthRefreshableClient().createSubcontractorUser(new CreateSubcontractorUserRequest({ name: name, email: email, groupId: groupId, diaryId: diaryId, roleId: roleId })));
    }

    public async GetDiaryUsersForGroupSubcontractor(groupId: number, buildingId: number): Promise<UsersGroupDiaryDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getDiaryUsersForGroupSubcontractor(groupId, buildingId)).users!;
    }

    public async GetMaterialsForRecordsExcelSubcontractor(diaryId: number, start: Date, end: Date): Promise<GetMaterialsForRecordTableDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getMaterialsForRecordsExcelSubcontractor(new GetMaterialsForRecordsExcelSubcontractorRequest({ diaryId: diaryId, start: start, end: end }))).materials!;
    }

    public async GetUserRoleForSubcontractor(): Promise<UserRoleDTO[]> {
        return (await this.GetAdressedAuthRefreshableClient().getUserRoleForSubcontractorSubcontractor()).roles!;
    }


    public async GetUsersForDiaryPrintSubcontractor(diaryId: number): Promise<UserDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getUsersForDiaryPrintSubcontractor(diaryId)).users;
    }

    public async PrintDiaryBackgroundSubcontractor(printType: DiaryPrintType, diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, dateFrom: Date | undefined, dateTo: Date | undefined, hasPhotos: boolean): Promise<void> {
        return (await this.GetAdressedAuthRefreshableClient().printDiaryBackgroundSubcontractor(new PrintDiaryBackgroundRequest({
            printType: printType,
            diaryId: diaryId,
            onlyMyNotes: onlyMyNotes,
            hasDigitalSignatureField: hasDigitalSignatureField,
            hasAttachments: hasAttachments,
            dateFrom: dateFrom,
            dateTo: dateTo,
            apiAdress: "",
            hasPhotos: hasPhotos
        })));
    }
}